<template>
	<div class="header_profitability_analysis is-full-width px-5 py-2">
		<p class="title">Análisis de Categorías</p>

		<div class="right_cluster is-flex is-align-items-center">
			<ReportExportButton class="drawer_export" />

			<button class="close_btn ml-3" aria-label="Cerrar modal" @click="$emit('close-modal')">
				<Ecs class="ecs" />
			</button>
		</div>
	</div>
</template>

<script>
import Ecs from "@/components/svg/Ecs.vue";
import ReportExportButton from "@/components/financialReports/ReportExportButton.vue";

// Header del drawer "Análisis de Categorías" (Rentabilidad): título, Exportar
// y cerrar. Los filtros (granularidad, rango y categorías) viven en el cuerpo
// con el formato del tab, y comparten su estado (plan de filtros, 2026-10-05).
export default {
	name: "HeaderProfitabilityAnalysis",
	components: { Ecs, ReportExportButton },
	props: {
		// `ModalFullHeightRight` le pasa `headerProps` como `payload`; este
		// header no lo usa.
		payload: { type: Object, default: null },
	},
};
</script>

<style scoped lang="scss">
.header_profitability_analysis {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 16px;
}

.title {
	color: var(--report-text);
	font-size: 28px;
	font-weight: 700;
	letter-spacing: -0.4px;
	margin: 0;
}

// Botón compartido del export (decisiones §34): trae su propio estilo;
// acá solo se iguala la altura con el botón de cerrar.
.drawer_export.export_btn {
	height: 46px;
}

.close_btn {
	width: 36px;
	height: 36px;
	border-radius: 8px;
	border: 1px solid var(--report-border-soft);
	background: var(--report-bg);
	box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05);
	box-sizing: border-box;
	overflow: hidden;
	padding-top: 5px;
	cursor: pointer;

	.ecs {
		width: 100%;
		position: relative;
		height: 20px;
		overflow: hidden;
		flex-shrink: 0;
	}
}
</style>
